
  const worksheetScan = {
    path: "/scan-worksheet-view/:id/:entryId?",
    name: "WorksheetScan",
    component: () => import(/* webpackChunkName: "scan-worksheet-view" */ "@/components/processWorksheet/WorksheetScanView.vue"),
    meta: { authorize: [], requiresAuth: true }
  };

export default worksheetScan;
    